import { render } from 'preact';
import { signal } from '@preact/signals';
import { Clock, Needs, OnlineChip, PhoneButton, PowerGlyph, Wallet, WalletFloaters } from './hud/widgets';
import { createBanner, createFloaters, ensureToast } from './hud/logic';
import { LightBanner, Toast } from './overlays/Overlays';
import { useEffect, useMemo } from 'preact/hooks';
import { BubbleLayer } from './world/BubbleLayer';
import { ChatBar } from './hud/ChatBar';
import { QuickChips } from './hud/QuickChips';
import { EmoteWheel } from './hud/EmoteWheel';
import './tokens.css';
export function UiRoot({ bridge, buttons, tick, onRender }) {
    const w = { bridge, ...(onRender ? { onRender } : {}) };
    const hud = useMemo(() => ({ fl: createFloaters(bridge), bn: createBanner(bridge), toasts: ensureToast(bridge) }), [bridge]);
    useEffect(() => () => { hud.fl.stop(); hud.bn.stop(); }, [hud]);
    return (<div class="ui-root">
      <div class="hud-top">
        <div class="hud-cluster">
          <Clock {...w}/>
          <PowerGlyph {...w}/>
          <OnlineChip bridge={bridge}/>
        </div>
        <div class="hud-cluster hud-right">
          <span class="hud-wallet-wrap"><WalletFloaters floaters={hud.fl.floaters}/><Wallet {...w}/></span>
          <PhoneButton {...w}/>
        </div>
      </div>
      <Needs {...w}/>
      <div class="hud-notices">
        <LightBanner banner={hud.bn.banner}/>
        <Toast queue={hud.toasts}/>
      </div>
      <BubbleLayer bridge={bridge}/>
      <div class="hud-chat">
        <QuickChips bridge={bridge}/>
        <div class="hud-chat-row">
          <ChatBar bridge={bridge}/>
          <EmoteWheel bridge={bridge}/>
        </div>
      </div>
      <div id="voiceSlot"/>
      <ButtonRow buttons={buttons} tick={tick}/>
    </div>);
}
function ButtonRow({ buttons, tick }) {
    void tick.value; // subscribe: refresh() re-renders only this row
    return (<div class="hud-bottom">
      {buttons.map((b) => (<button key={b.id} type="button" class="chip" data-id={b.id} onClick={(e) => {
                e.stopPropagation();
                b.onClick();
                tick.value++;
            }} onPointerDown={(e) => e.stopPropagation()}>
          {b.label()}
        </button>))}
    </div>);
}
/** Mount the Preact UI into `el`. Replaces the M0 DOM `Hud`. */
export function mountUi(el, bridge, buttons = []) {
    const tick = signal(0);
    // Own container: preact's render() would otherwise remove siblings it doesn't know (the canvas).
    const host = document.createElement('div');
    host.className = 'ui-host';
    el.appendChild(host);
    render(<UiRoot bridge={bridge} buttons={buttons} tick={tick}/>, host);
    return {
        refresh: () => {
            tick.value++;
        },
        unmount: () => {
            render(null, host);
            host.remove();
        },
    };
}
